import Trulioo from './Trulioo';

export default Trulioo;
